import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import logo from "../assets/images/round_logo.png";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../services/baseurl";
import { loginEndpoint, loginOTPEndpoint } from "../services/endpoints";
import { toast } from "react-toastify";
import { LockIcon, UserIcon } from "../assets/icon";
import Loader from "../components/loader";
import styles from "../css/login.module.css";

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [userNameErr, setUserNameErr] = useState(false);
  const [passwordErr, setPasswordErr] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpSessionDetails, setOtpSessionDetails] = useState("");
  const [verifyClicked, setVerifyClicked] = useState(false)

  const handleUsernameChange = (e) => {
    setUsername(e.target.value.replace(/\D/g, "").slice(0, 10));
    setOtpSent(false);
    setPassword("");
    setOtpSessionDetails("");
    setVerifyClicked(false);
    setUserNameErr(false);
    setPasswordErr(false)
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value.replace(/\D/g, "").slice(0, 6));
    setPasswordErr(false);
  };

  const handleLoginOtp = () => {
    if (verifyClicked || isLoading) return;
    setVerifyClicked(true)
    if (username !== "9000066100" || !/^\d{10}$/.test(username)) {
      setUserNameErr(true);
      setVerifyClicked(false)
      return
    } else {
      setUserNameErr(false);
    }
    const requestData = {
      phone: username,
    };
    axiosInstance
      .post(loginEndpoint, requestData)
      .then((response) => {
        if (response.data.status === "Success") {
          setOtpSessionDetails(response.data.payload)
          setOtpSent(true);
          setVerifyClicked(false);
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
          setVerifyClicked(false)
        }
       
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || error.message || "Unable to sign in. Please try again.");
        setVerifyClicked(false)
      });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoading || verifyClicked && !otpSent) return;
    if (!otpSent) {
      handleLoginOtp();
      return;
    }
    if (!username) {
      setUserNameErr(true);
    } else {
      setUserNameErr(false);
    }
    if (!password) {
      setPasswordErr(true);
    } else {
      setPasswordErr(false);
    }
    if (/^\d{10}$/.test(username) && /^\d{6}$/.test(password) && otpSessionDetails) {
      setIsLoading(true);
      const requestData = {
        sessionID: otpSessionDetails ? parseInt(otpSessionDetails) : 0,
        otp: password,
      };
      
      axiosInstance
        .post(loginOTPEndpoint, requestData)
        .then((response) => {
          if (response.data.status === "Success") {
            let { name, userId, token } = response.data.payload
            sessionStorage.setItem('name', name);
            sessionStorage.setItem('userId', userId);
            sessionStorage.setItem('token', token);
            toast.success(response.data.message);
            navigate("/dashboard");
          } else {
            toast.error(response.data.message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || error.message || "Unable to sign in. Please try again.");
          setIsLoading(false);
        });
    } else {
      setPasswordErr(true);
    }
  };

  return (
    <div className={styles.login}>
      {isLoading && <Loader />}
      <div className={styles.loginContainer}>
        <Container className={styles.loginMainContainer}>

          <form onSubmit={handleSubmit} className={styles.loginFormContainer}>
            <Link to="/" className={styles.homeLink}>← Back to home</Link>
            <img src={logo} alt="Buyandwin" className={styles.logoImage} />
            <span className={styles.eyebrow}>BUYANDWIN ADMIN</span>
            <div style={{ width: "100%" }}>
              <h3 className={styles.loginHeading}>Login</h3>
              <p className={styles.loginDescription}>Welcome back. Sign in with your mobile number.</p>
              <div className={styles.loginInputContainer}>
                <label htmlFor="username" className={styles.loginInputLables}>
                  Mobile No
                </label>
                <div className={styles.loginInputMain}>
                  <input
                    type="text"
                    id="username"
                    value={username}
                    onChange={handleUsernameChange}
                    className={styles.loginInput}
                    placeholder="Enter Mobile No"
                    inputMode="tel"
                    autoComplete="tel"
                    aria-invalid={userNameErr}
                    disabled={verifyClicked || isLoading}
                    maxLength={10}
                  />
                  <div className={styles.loginInputIconMain}>
                    <UserIcon />
                  </div>
                </div>
                {userNameErr && (
                  <small className={styles.loginInputValidationText}>
                    Mobile No is required!
                  </small>
                )}
              </div>
              {!otpSent &&
                <div className={styles.loginButtonContainer}>
                  {!verifyClicked && <Button type="button" className={styles.loginSubmitButton} onClick={handleLoginOtp} disabled={username !== "9000066100" || verifyClicked || isLoading}>
                      Verify
                  </Button>}
                  {verifyClicked && <div className={styles.pendingStatus} role="status">Sending verification code…</div>}
                </div>}
              {otpSent &&
                <div>
                  <div className={styles.loginInputContainer}>
                    <label htmlFor="password" className={styles.loginInputLables}>
                      OTP:
                    </label>
                    <div className={styles.loginInputMain}>
                      <input
                        type={"text"}
                        id="password"
                        value={password}
                        onChange={handlePasswordChange}
                        className={styles.loginInput}
                        placeholder="Enter OTP"
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        aria-invalid={passwordErr}
                        maxLength={6}
                      />
                      <div className={styles.loginInputIconMain}>
                        <LockIcon />
                      </div>
                    </div>
                    {passwordErr && (
                      <small className={styles.loginInputValidationText}>
                        OTP is required!
                      </small>
                    )}
                  </div>
                  <div className={styles.loginButtonContainer}>
                    <Button type="submit" className={styles.loginSubmitButton}  disabled={isLoading || !/^\d{6}$/.test(password)}>Login
                    </Button>
                  </div>
                </div>}
            </div>
            <p className={styles.securityNote}><span aria-hidden="true">✓</span> Secure mobile verification</p>
          </form>
        </Container>
      </div>
    </div>
  );
};

export default LoginPage;
